<template>
    <div class="top flex items-center">
        <div
            v-if="topIcon"
            class="iconHolder flex justify-center items-center"
        >
            <slot/>
        </div>
        <h3 class="heading">
            {{ heading }}
        </h3>
    </div>
</template>

<script>
export default {
    props: {
        heading: {
            type: String,
            required: true,
        },
        topIcon: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="postcss" scoped>
.top {
    margin-bottom: 15px;
}
.iconHolder {
    width: 38px;
    height: 38px;
    border-radius: 100%;
    background-color: var(--grey200);
    color: var(--primaryTextColor);
    margin-right: 12px;
}
.icon {
    width: 20px;
    height: 20px;
}
.heading {
    margin-bottom: 0;
}
</style>
